import React from "react";
import "./index.scss";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer>
      <ul>
        <li>
          <Link to="/impressum" target="_blank">
            Impressum
          </Link>
        </li>
        <li>
          <Link to="/datenschutz" target="_blank">
            Datenschutz
          </Link>
        </li>
        <li>
          <Link to="/faq" target="_blank">
            Hilfe
          </Link>
        </li>
        <li>&copy; 2019 Ilex App</li>
      </ul>
    </footer>
  );
};

export default Footer;
